/**
 * Generates URL functions for the Compass tab, with appropriate absolute URLs.
 *
 * @returns functions for generating Compass URLs
 */
export const compassURLGenerators = baseUrlOverride => {
  const baseUrl = baseUrlOverride || window.location.origin;
  const advancedSearchLinkGenerator = query => `${baseUrl}/compass/components?query=${encodeURIComponent(query)}`;
  const teamUrlGenerator = teamId => `${baseUrl}/compass/people/team/${teamId}`;
  const userUrlGenerator = userId => `${baseUrl}/people/${userId}`;
  return {
    advancedSearchLinkGenerator,
    teamUrlGenerator,
    userUrlGenerator
  };
};